import { render } from "./StoreItem.vue?vue&type=template&id=96a14a9e&scoped=true"
import script from "./StoreItem.vue?vue&type=script&lang=js"
export * from "./StoreItem.vue?vue&type=script&lang=js"

import "./StoreItem.vue?vue&type=style&index=0&id=96a14a9e&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96a14a9e"]])

export default __exports__